module.exports = {
      id: "calendar-usage",
      viewBox: "0 0 17.552 17.301",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#calendar",
      toString: function () {
        return this.url;
      }
    }